export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_975f3a6205516cda732ff262